import React from 'react'
import { Stack, Title, createStyles, Grid, Text, useMantineTheme } from '@mantine/core'
import { useMediaQuery } from '@mantine/hooks'
import { Trans, useTranslation } from 'react-i18next'
import stepGif from '../../assets/gifs/stepper_01.gif'

const useStyles = createStyles(theme => ({
  panel: {
    display: 'flex',
    justifyContent: 'center',
    margin: 'auto',
    padding: 0,
    width: '100%',
  },
  info: {
    flexDirection: 'column',
    backgroundColor: theme.colors.background[0],
    color: theme.colors.title[0],
    textAlign: 'left',
    maxWidth: '80%',
  },
  textArea: {
    fontSize: '30px',
    [`@media (max-width: ${theme.breakpoints.sm})`]: {
      fontSize: '25px',
    },
    [`@media (max-width: ${theme.breakpoints.xs})`]: {
      fontSize: '20px',
    },
  },
  graphic: {
    width: '100%',
    height: '98vh',
    objectFit: 'cover',
    // fade last 50px from image
    maskImage: 'linear-gradient(to bottom, rgba(0,0,0,1), rgba(0,0,0,0))',
    [`@media (max-width: ${theme.breakpoints.lg})`]: {
      width: '100%',
      height: '30vh',
    },
    [`@media (max-width: ${theme.breakpoints.xs})`]: {
      width: '100%',
      height: '25vh',
    },
  },
}))

const Step1: React.FC = () => {
  const { t } = useTranslation()
  const theme = useMantineTheme()
  const { classes } = useStyles()
  const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.xs})`)
  const isDownLg = useMediaQuery(`(max-width: ${theme.breakpoints.lg})`)

  return (
    <Grid sx={{ flexDirection: isDownLg ? 'column-reverse' : 'row' }}>
      <Grid.Col span="auto" className={classes.panel}>
        <Stack className={classes.info} spacing="3em">
          <Title order={isMobile ? 3 : 2}>
            <Trans i18nKey="components.stepper.1.text1">
              Hello,
              <br /> Builder.
            </Trans>
          </Title>
          <Text className={classes.textArea}>
            {isMobile
              ? t(
                  'components.stepper.1.text2Mobile',
                  'The Hub is a testing and development ground for the LAMINA1 Betanet.'
                )
              : t(
                  'components.stepper.1.text2',
                  'The Hub is a testing and development ground for the LAMINA1 Betanet. It’s where L1 and the open metaverse will begin to take shape with our dedicated community of builders and creators.'
                )}
          </Text>
        </Stack>
      </Grid.Col>
      <Grid.Col span="auto" className={classes.panel}>
        <img className={classes.graphic} src={stepGif} alt="step1" />
      </Grid.Col>
    </Grid>
  )
}

export default Step1
